import { alpha, Chip } from '@mui/material';
import { Flag2, MoneyRecive, MoneySend } from 'iconsax-react';
import { grey } from '@mui/material/colors';

function StatusIcon({ status }) {
  if (status === "Aumento") {
    return <Chip
      sx={{
        color: '#53CA98',
        backgroundColor: alpha(
          '#53CA98',
          0.1
        ),
      }}
      label='Aumento'
      icon={
        <MoneyRecive size="20" variant="Outline"/>
      }
      size="small"
    />
  } if(status === "Reducción") {
    return <Chip
      sx={{
        color: '#DB463C',
        backgroundColor: alpha(
          '#DB463C',
          0.1
        ),
      }}
      label='Reducción'
      icon={
        <MoneySend size="20" variant="Outline"/>
      }
      size="small"
    />
  } else {
    return <Chip
      sx={{
        color: grey,
        backgroundColor: alpha(
          grey[500],
          0.1
        ),
      }}
      label='???'
      icon={
        <Flag2 size="20" variant="Outline"/>
      }
      size="small"
    />
  }
}

export const columns = [
  {
    field: "type_case",
    headerName: "TIPO",
    width: 120,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>TIPO</strong>,
    renderCell: (params) => <StatusIcon status={params.value} />,
  },
  {
    field: "amount",
    headerName: "CANTIDAD",
    minWidth: 100,
    resizable: false,
    sortable: false,
    align: "left",
    renderHeader: (params) => <strong>CANTIDAD</strong>,
  },
  {
    field: "description_case",
    headerName: "DESCRIPCIÓN",
    minWidth: 240,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>DESCRIPCIÓN</strong>,
  },
  {
    field: "before_balance",
    headerName: "CRÉDITOS \nANTERIORES",
    type: "string",
    minWidth: 190,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "right",
    renderHeader: (params) => <strong>CRÉDITOS ANTERIORES</strong>,
  },
  {
    field: "after_balance",
    headerName: "CRÉDITOS ACTUALES",
    type: "string",
    width: 180,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "right",
    renderHeader: (params) => <strong>CRÉDITOS ACTUALES</strong>,
  },
  {
    field: "register_date",
    headerName: "FECHA DE REGISTRO",
    type: "string",
    width: 180,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>FECHA DE REGISTRO</strong>,
  },
];
